import apiService from '../core/services/network.service';
import * as endpoints from '../constants/endpoints';
import TokenService from './token.service';
import { toast } from 'react-toastify';
import i18n from '../i18n/i18n';

class AuthService {
  async login(email: string, password: string) {
    try {
      const response = await apiService.axiosInstance.post(
        endpoints.LOGIN,
        { email, password },
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      if (response.data.access) {
        TokenService.setUser(response.data);
        return response.data;
      }
    } catch (error) {
      toast.error(i18n.t('messages.credentialError'), {
        position: 'top-center',
        autoClose: 5000,
        theme: 'light',
      });
    }
  }
}

export default new AuthService();
